import { render, staticRenderFns } from "./WorkSchedules.vue?vue&type=template&id=805b7842"
import script from "./WorkSchedules.vue?vue&type=script&lang=js"
export * from "./WorkSchedules.vue?vue&type=script&lang=js"
import style0 from "./WorkSchedules.vue?vue&type=style&index=0&id=805b7842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports